module.exports = __webpack_public_path__ + "static/ByteCamp-Info-dark-879127eccc3cd7542eaecf346e170292.svg";